import type { TeamTask } from "../types";
import { TeamTaskCreate, TeamTaskEdit } from "./TeamTaskEdit";
import { TeamTaskList } from "./TeamTaskList";

export default {
  list: TeamTaskList,
  create: TeamTaskCreate,
  edit: TeamTaskEdit,
  recordRepresentation: (record: TeamTask) => record.title,
};
